import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FormatTab = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 18 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.44788 3.52545H3.5L3.5 5.69212H2.5V3.52545V2.52545H15.5V3.52545H15.498V5.69212H14.498V3.52545H9.44788L9.44788 14.9942H11.6562V15.9942H9.44788V16H8.44788V15.9942H6.34375V14.9942H8.44788L8.44788 3.52545Z"
      />
    </svg>
  )
})

export default FormatTab
